export const MobileId = ({ size = 29 }) => {
  return (
    <svg
      width={(size * 96) / size}
      height={size}
      viewBox="0 0 96 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_25711)">
        <mask
          id="mask0_2_25711"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="96"
          height="29"
        >
          <path
            d="M95.561 0.0913086H0V28.0849H95.561V0.0913086Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2_25711)">
          <path
            d="M13.9943 28.0849C21.7234 28.0849 27.9886 21.819 27.9886 14.0878C27.9886 6.35649 21.7234 0.0913086 13.9943 0.0913086C6.26518 0.0913086 0 6.3572 0 14.0885C0 21.8197 6.26589 28.0856 13.9943 28.0856V28.0849Z"
            fill="#076CE3"
          />
          <path
            d="M14.894 22.6128C19.5638 22.5112 23.2088 18.8513 23.3168 14.7174C23.4063 11.3012 21.0661 8.03291 17.5107 6.81909"
            stroke="white"
            strokeWidth="0.951574"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M14.7867 15.2668C15.1243 15.2668 15.3979 14.9925 15.3979 14.6556C15.3979 14.3187 15.1243 14.0444 14.7867 14.0444C14.4491 14.0444 14.1755 14.3173 14.1755 14.6556C14.1755 14.9939 14.4491 15.2668 14.7867 15.2668Z"
            fill="white"
            stroke="white"
            strokeWidth="0.135736"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M7.27222 6.82349C7.98714 7.91719 10.984 11.6965 10.984 11.6965C10.984 11.6965 14.3532 7.57465 14.7619 6.82349"
            stroke="white"
            strokeWidth="0.951574"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M7.27222 19.2778V6.82349"
            stroke="white"
            strokeWidth="0.951574"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.8521 12.69V6.82349"
            stroke="white"
            strokeWidth="0.951574"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.7617 22.617V16.7505"
            stroke="white"
            strokeWidth="0.951574"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.8175 16.7492L38.5135 13.795V19.66H36.6907V10.0498H37.8498L41.1003 14.4879L44.0538 10.0498H45.1703V19.66H43.319V14.1197L41.5239 16.6504L40.8175 16.7499V16.7492ZM50.3801 19.8299C49.2964 19.8299 48.4485 19.5051 47.836 18.8541C47.2326 18.1954 46.9313 17.3141 46.9313 16.2112C46.9313 15.1083 47.2468 14.2477 47.8779 13.5967C48.5182 12.9471 49.3902 12.6224 50.4924 12.6224C51.5946 12.6224 52.5135 12.9606 53.1353 13.64C53.7664 14.3088 54.0819 15.1893 54.0819 16.2816C54.0819 17.3738 53.743 18.2423 53.0643 18.8826C52.3856 19.5144 51.4909 19.8299 50.3787 19.8299H50.3801ZM52.1895 16.2816C52.1895 15.632 52.0431 15.1239 51.7517 14.7558C51.4688 14.3791 51.0638 14.1908 50.5365 14.1908C50.0092 14.1908 49.5799 14.3564 49.2786 14.6854C48.9773 15.0159 48.8266 15.5197 48.8266 16.1977C48.8266 16.8757 48.9538 17.3895 49.2082 17.7384C49.4719 18.0859 49.8727 18.26 50.4093 18.26C50.9458 18.26 51.3658 18.1051 51.6955 17.7938C52.0253 17.4733 52.1902 16.9702 52.1902 16.2816H52.1895ZM57.4725 9.68237V13.0175C57.7461 12.8668 58.0332 12.7482 58.3345 12.6643C58.6458 12.5797 58.9237 12.5364 59.1681 12.5364C60.1766 12.5364 60.9491 12.8853 61.4856 13.5825C62.0229 14.2796 62.2915 15.1466 62.2915 16.1835C62.2915 17.2203 62.0136 18.0859 61.4579 18.7831C60.9114 19.4802 60.1481 19.8292 59.1681 19.8292C58.8476 19.8292 58.4895 19.7624 58.0943 19.6309C57.6985 19.4994 57.3453 19.3154 57.034 19.0808L56.582 19.66H55.649V9.8373L57.4718 9.68237H57.4725ZM58.6877 18.26C59.3188 18.26 59.7615 18.0348 60.016 17.5821C60.2704 17.1201 60.3976 16.6539 60.3976 16.1835C60.3976 15.6455 60.2846 15.1658 60.0586 14.7416C59.8326 14.3173 59.3757 14.1055 58.6877 14.1055C58.4902 14.1055 58.2827 14.1439 58.0659 14.2185C57.8584 14.2853 57.6608 14.3791 57.4725 14.5014V17.8649C57.6608 17.9779 57.8591 18.0731 58.0659 18.1478C58.2827 18.2238 58.4902 18.2607 58.6877 18.2607V18.26ZM64.6807 9.76694C64.9728 9.76694 65.218 9.86643 65.4155 10.0633C65.6231 10.2616 65.7268 10.506 65.7268 10.7988C65.7268 11.0916 65.6231 11.3354 65.4155 11.5336C65.218 11.7319 64.9728 11.83 64.6807 11.83C64.3886 11.83 64.1577 11.7319 63.9601 11.5336C63.7626 11.3354 63.6631 11.0909 63.6631 10.7988C63.6631 10.5067 63.7618 10.2623 63.9601 10.0633C64.1577 9.86643 64.3979 9.76694 64.6807 9.76694ZM65.5996 12.8057V19.66H63.7626V12.8057H65.5996ZM69.3007 9.68308V19.66H67.4779V9.8373L69.3007 9.68237V9.68308ZM74.6797 19.8299C73.4929 19.8299 72.5548 19.5051 71.8676 18.8541C71.189 18.2046 70.85 17.3319 70.85 16.2396C70.85 15.1473 71.1563 14.2704 71.7688 13.6116C72.3907 12.9514 73.2342 12.6224 74.2988 12.6224C75.3634 12.6224 76.16 12.9798 76.6589 13.6962C77.1677 14.4026 77.4221 15.2412 77.4221 16.2112V16.7762H72.8007C72.8853 17.2289 73.0928 17.5913 73.4226 17.8649C73.7523 18.1286 74.1858 18.26 74.7231 18.26C75.0343 18.26 75.3122 18.2231 75.5567 18.147C75.8111 18.0625 76.1032 17.9445 76.4329 17.7938L76.9702 19.1228C76.6497 19.3672 76.2588 19.547 75.7969 19.6593C75.3449 19.7723 74.9725 19.8292 74.6804 19.8292L74.6797 19.8299ZM75.6832 15.5482C75.5886 15.0862 75.4195 14.7465 75.1743 14.5305C74.9292 14.3038 74.6229 14.1908 74.2554 14.1908C73.888 14.1908 73.5633 14.3088 73.3089 14.544C73.0544 14.7707 72.8896 15.1054 72.8142 15.5482H75.6832ZM82.0279 16.509H78.3396L78.184 15.067H81.8865L82.0279 16.509ZM85.26 10.0498V19.66H83.4372V10.0498H85.26ZM91.1372 19.66H87.6322V10.0498H91.194C92.6736 10.0498 93.7709 10.4968 94.4872 11.3922C95.2036 12.2877 95.561 13.4226 95.561 14.7977C95.561 16.2872 95.1751 17.4691 94.4019 18.346C93.6295 19.2223 92.5414 19.66 91.1372 19.66ZM91.2075 11.604H89.455V18.1186H91.1087C91.8812 18.1186 92.4988 17.8642 92.96 17.3561C93.4312 16.8465 93.6664 15.9945 93.6664 14.797C93.6664 13.7985 93.4689 13.0168 93.073 12.4518C92.6772 11.8868 92.0554 11.604 91.2075 11.604Z"
            fill="#076CE3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2_25711">
          <rect
            width="95.5838"
            height="28"
            fill="white"
            transform="translate(0 0.0913086)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
